export enum SupportedLanguage {
  EN = "en",
  AR = "ar",
}

export type Direction = "ltr" | "rtl";

export const LanguageConfig: Record<
  SupportedLanguage,
  { name: string; menuName: string; direction: Direction; flag: string }
> = {
  [SupportedLanguage.EN]: {
    name: "EN",
    menuName: "English",
    direction: "ltr",
    flag: "🇬🇧",
  },
  [SupportedLanguage.AR]: {
    name: "AR",
    menuName: "العربية",
    direction: "rtl",
    flag: "🇸🇦",
  },
};

export const DEFAULT_LANGUAGE = SupportedLanguage.EN;
export const LANGUAGE_STORAGE_KEY = "blink_language";
